import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import { IUnavailableTimeSlotsByTokenPayload } from '@store/slices/meetingRequests/unavailableTimeSlotsByToken'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: IUnavailableTimeSlotsByTokenPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingRequests.unavailableTimeSlotsByToken

function* uavailableTimeSlotsByTokenTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/meeting-requests/unavailable-slots`, {
            params: payload.data
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload?.sagaCB?.onError) payload?.sagaCB?.onError(error)
    }
}

function* uavailableTimeSlotsByToken(): any {
    yield takeLatest<TaskAction>(onRequest, uavailableTimeSlotsByTokenTask)
}

export default uavailableTimeSlotsByToken
